import { getUrlsTable } from '@repo/shared-config/app/constants/hosts';
import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';

const environment = getEnvironmentVariables();

export const authBaseURL = getUrlsTable(environment).backendUrlsTable.authBaseURL;
export const segmentConfig = environment.metricsAdaptersConfig?.Segment.config;
// oxlint-disable-next-line typescript/no-unnecessary-condition -- Todo: getEnvironmentVariables return type doesn't reflect reality
export const deployTarget = environment.deployTarget || 'development';
export const stagingAccessToken = environment.stagingAccessToken;
